import {api, commonApiWrapper} from "@/services/common-api";
import {ICoupon} from "@/app/dashboard/models/Coupon";

export const getCouponCodeData = (couponCode: string, eventId: string) => commonApiWrapper<ICoupon>(api.get('coupons/validate', {params: {couponCode, eventId}}))